import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

export type SkeletonVariant = 'text' | 'block' | 'circle';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
    variant?: SkeletonVariant;
    width?: number | string;
    height?: number | string;
}

const VARIANT_CLASSES: Record<SkeletonVariant, string> = {
    text: 'rounded-control h-4 w-full',
    block: 'rounded-control w-full h-24',
    circle: 'rounded-full h-10 w-10',
};

const BASE_CLASSES = 'bg-space-800 animate-pulse motion-reduce:animate-none';

/**
 * Shimmer placeholder replacing the invisible `text-space-500` "Loading…"
 * strings — see @docs/design-system.md §1.2 on why that colour fails AA.
 */
export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton(
    { variant = 'block', width, height, className, style, ...rest },
    ref,
) {
    return (
        <div
            ref={ref}
            className={cn(BASE_CLASSES, VARIANT_CLASSES[variant], className)}
            style={{ width, height, ...style }}
            {...rest}
        />
    );
});

export default Skeleton;
